const partnershipDescriptor = parntershipSection.find('.partnership-topper-description');

const addEducatorsAnimation = () => {
  const educatorsTL = gsap.timeline({ paused: true });

  /*
  educatorsTL.add(
    animateSectionTopperIn({
      sectionParent: parntershipSection,
    }).play(),
    0
  );
  */

  educatorsTL.add(elementInAnimationYWOpacity(partnershipDescriptor, '100%', 0, 1, 1, 1, 0, 0, 'start', 'pageInEasing', 'pageInEasing').play(), 0.1);
  educatorsTL.add(elementInAnimationYWOpacity(parntershipDescriptorCards, '100%', 0, 1, 1, 1, 0, 0.1, 'start', 'pageInEasing', 'pageInEasing').play(), 0.1);
  educatorsTL.add(elementInAnimationYWOpacity(partnershipPoints, '50%', 0, 1, 1, 1, 0, 0.1, 'start', 'pageInEasing', 'pageInEasing').play(), 0.3);

  return educatorsTL;
};

const initEducatorsPartnership = () => {
  educatorsImagesSet();
  addCardPhotoAnimation();
  if(isDesktop()){
    const educatorsTL = addEducatorsAnimation();
    ScrollTrigger.create({
      trigger: parntershipSection,
      start: 'top center',
      end: 'top top',
      once: true,
      onEnter: () => {
        educatorsTL.play();
      },
    });
  }
}

/*
$(window).on('load', () => {
  initEducatorsPartnership();
});
*/

addSectionObserver(parntershipSection, initEducatorsPartnership);
